// # Profile routes configuration
import React, { useEffect } from 'react';
import { useParams, useNavigate, Route, Navigate } from 'react-router-dom';
import { db } from '../../auth/firebase';
import { doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';
import Profile from '../../general/profile/profile';
import { useAuthStore } from '../../auth/state';

// # PublicProfileWrapper component that wraps the Profile component with username parameter handling
const PublicProfileWrapper = () => {
  const { username } = useParams();
  const { user, userProfile, isLoading } = useAuthStore();
  const navigate = useNavigate();

  // # Check if the user is viewing their own profile through the username URL
  useEffect(() => {
    if (isLoading || !user || !userProfile) return;
    
    // # If user is viewing their own profile via username, redirect to /profile
    if (userProfile.username === username) {
      console.log('User is viewing their own profile via username, redirecting to /profile');
      navigate('/profile', { replace: true });
    }
  }, [username, user, userProfile, isLoading, navigate]);
  
  // # Pass the username prop to the Profile component
  // # The Profile component will handle loading the user data
  return <Profile viewUsername={username} isPublicView={true} />;
};

// # MyProfileWrapper component that redirects to the authenticated user's profile
const MyProfileWrapper = () => {
  const { user, userProfile, isLoading } = useAuthStore();
  const navigate = useNavigate();
  
  // # Show loading state while checking authentication
  if (isLoading) {
    return <div className="prfl_profile-loading">Loading profile...</div>;
  }
  
  // # If user is not authenticated, redirect to login
  if (!user) {
    return <Navigate to="/login" />;
  }
  
  // # If user is authenticated but username is not loaded yet
  if (!userProfile?.username) {
    return <div className="prfl_profile-loading">Loading profile...</div>;
  }
  
  // # Redirect authenticated admin users to admin profile
  if (isLoading === false && user && userProfile?.isAdmin) {
    return <Navigate to="/admin/profile" />;
  }
  
  // # Pass null for viewUsername to indicate it's the authenticated user's profile
  return <Profile viewUsername={null} isPublicView={false} />;
};

// # Export routes configuration
const profileRoutes = [
  // # 'me' route for the currently authenticated user
  {
    path: '/profile/me',
    element: <MyProfileWrapper />,
  },
  // # Username-based public profile route
  {
    path: '/profile/:username',
    element: <PublicProfileWrapper />,
  },
];

export default profileRoutes;
